import React, { useEffect, useState } from 'react';
import api from '../../config/axios';
import Swal from 'sweetalert2';

import UnidadeModal from './modals/Unidade';
import '../../assets/styles/index.css';

const Usuarios = () => {
  const [usuario, setUsuario] = useState(null);
  const [nome, setNome] = useState('');
  const [unidadeSelecionada, setUnidadeSelecionada] = useState('');
  const [gestoraId, setGestoraId] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchUsuario = async () => {
    try {
      Swal.fire({
        title: 'Carregando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await api.get('/pessoas/me');
      const usuarioData = response.data;
      
      setUsuario(usuarioData);
      setNome(usuarioData.nome || '');
      setUnidadeSelecionada(usuarioData.dadosColaborador.unidade || '');
      setGestoraId(usuarioData.dadosColaborador.gestora_designacao_id || '');
      
      Swal.close();
    } catch (err) {
      Swal.close();
      Swal.fire('Erro', 'Não foi possível carregar dados do usuário.', 'error');
    }
  };

  useEffect(() => {
    fetchUsuario();
  }, []);

  const handleUnidadeSelecionada = (unidade) => {
    if (!unidade) {
      setUnidadeSelecionada(null);
      return;
    }

    const data = {
        id: unidade.value,
        nome: unidade.label
    }
    setUnidadeSelecionada(data);
  };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Editar Usuário</h4>
            </div>
          </div>
          
          <div className="row mt-3">
            <div className="col-12">
              <p className="mb-0"><strong>Nome:</strong> {nome || 'Carregando...'}</p>
            </div>
          </div>
          
          <div className="row mt-4 mb-4">
            <div className="col-lg-5 col-md-6 col-12">
              <label className="form-label fw-bold">Unidade</label>
              <div className="d-flex flex-column flex-md-row gap-2 align-items-md-center">
                <p className="mb-0 text-start">
                  {unidadeSelecionada ? unidadeSelecionada.nome : 'Nenhuma unidade selecionada'}
                </p>
                <button
                  className="btn btn-outline-primary"
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                >
                  Selecionar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: '50px' }}></div>

      <UnidadeModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onUnidadeSelecionada={handleUnidadeSelecionada}
        unidadeSelecionada={unidadeSelecionada}
        gestoraId={gestoraId}
        usuario={usuario}
      />
    </div>
  );
};

export default Usuarios;
